import { IsString, IsInt, IsOptional } from 'class-validator';

export class ActuationResponseDTO {
    @IsString()
    message!: string;

    @IsInt()
    httpStatus!: number;

    @IsOptional()
    @IsString()
    success?: string;
}
